import { Anchor } from '@vivino/js-web-common';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './noteTag.scss';

const NoteTag = ({ keyword, selected, onClick, noteGroup }) => {
  const count = keyword.count >= 1000 ? `${Math.round(keyword.count / 1000)}k` : keyword.count;
  return (
    <Anchor
      onClick={onClick}
      className={cx(styles.noteTag, styles[noteGroup], {
        [styles.selected]: selected,
      })}
      id={keyword.id.toString()}
    >
      <div className={styles.count}>
        <div className={styles.number}>{count}</div>
      </div>
      <div className={styles.name}>{keyword.name}</div>
    </Anchor>
  );
};

NoteTag.propTypes = {
  keyword: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  noteGroup: PropTypes.string,
};

export default NoteTag;
